<template>
  <div class="roster_leave_settings pt-4 roster-page roster-leave-policies-page">
    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">

      <employee-public-info :hidebacknext="true"></employee-public-info>

      <template v-if="leave_available.length > 0">
        <template v-if="startDate.length > 0">

          <div class="row">

            <div class="col-sm-8">
              <div class="ibox p-2">
                <div class="ess-roster-leave-application pt-3 rounded">
                  <div class="card-header rounded border-0 text-muted mx-3 date-0 text-center py-2 d-flex align-items-center justify-content-center">
                    <img src="/images/la/Leave-Application.svg" alt="" class="mr-2">
                    <div>
                      (Leave Year/Contract Date Range From <strong>{{ startDate }}</strong> To <strong>{{ endDate }}</strong>)
                    </div>
                  </div>
                </div>
                <div class="card-body">

                  <b-alert show variant="danger" v-for="error in errors" :key="error">{{ error }}</b-alert>

                  <div v-if="toggle_reset" class="row">
                    <div class="col-sm-6">
                      <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text">
                        <b-input-group class="mb-3">
                          <b-form-input v-model="day_one" type="text" disabled></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </div>

                    <div class="col-sm-6">
                      <b-form-group id="day_two-group" label="To [YYYY-MM-DD]" label-for="day_two_text">
                        <b-input-group class="mb-3">
                          <b-form-input v-model="day_two" type="text" disabled></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="row" :class="editable">

                    <div class="col-sm-6">
                      <b-form-group class="w-100" label="Leave Day" label-for="leave_day">
                        <b-form-select
                          id="leave_day"
                          name="leave_day"
                          v-model="fdata.leave_day"
                          :options="leaveDay"
                          :disabled="toggle_reset"
                          @change="reloadType"
                        ></b-form-select>
                      </b-form-group>
                    </div>

                    <div class="col-sm-6">
                      <b-form-group
                        id="leave_type_id-group"
                        label="Leave Category"
                        class="required-field w-100"
                        label-for="leave_type_id"
                      >
                        <b-form-select
                          id="leave_type_id"
                          name="leave_type_id"
                          v-model="fdata.leave_type_id"
                          :disabled="toggle_reset"
                          @change="updateToDate"
                          v-validate="{ required: true }"
                          :state="validateState('leave_type_id')"
                          aria-describedby="leave_type_id-feedback"
                          data-vv-as="Leave Category"
                        >
                          <b-form-select-option
                            v-for="leave_type in leavetypes"
                            :key="leave_type.leave_type_id"
                            :value="leave_type.leave_type_id"
                          >{{ leave_type.leave_type_title }}</b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback id="leave_type-feedback">{{ veeErrors.first('leave_type_id') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </div>

                    <div class="col-sm-6" v-if="fdata.leave_type_id != null">
                      <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text" class="required-field w-100">
                        <b-input-group class="mb-3">
                          <b-form-input
                            id="day_one_text"
                            name="day_one_text"
                            v-model="day_one"
                            :disabled="period_date != undefined"
                            v-validate="{ required: true }"
                            type="text"
                            placeholder="YYYY-MM-DD"
                            autocomplete="off"
                            @change="updateToDate"
                            :state="validateState('day_one_text')"
                            aria-describedby="day_one_text-feedback"
                            data-vv-as="From Date"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              id="day_one"
                              v-model="day_one"
                              :disabled="period_date != undefined"
                              @context="updateToDate()"
                              button-only
                              right
                              locale="en-US"
                              :date-disabled-fn="dateDisabled"
                              :start-weekday="fetchStartWeekday"
                            ></b-form-datepicker>
                          </b-input-group-append>
                          <b-form-invalid-feedback id="day_one_text-feedback">{{ veeErrors.first('day_one_text') }}</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </div>

                    <div class="col-sm-6" v-if="fdata.leave_type_id != null">
                      <b-form-group
                        class="required-field w-100"
                        id="day_two-group"
                        label="To [YYYY-MM-DD]"
                        label-for="day_two_text"
                        :class="{ 'd-none': fdata.leave_day > 0 }"
                      >
                        <b-input-group class="mb-3">
                          <b-form-input
                            id="day_two_text"
                            name="day_two_text"
                            v-model="day_two"
                            :disabled="period_date != undefined || (leaveType != null && leaveType.event > 0)"
                            v-validate="{ required: true }"
                            type="text"
                            placeholder="YYYY-MM-DD"
                            autocomplete="off"
                            @change="adjustValidDate"
                            :state="validateState('day_two_text')"
                            aria-describedby="day_two_text-feedback"
                            data-vv-as="To Date"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              id="day_two"
                              v-model="day_two"
                              :disabled="period_date != undefined || (leaveType != null && leaveType.event > 0)"
                              @context="adjustValidDate()"
                              button-only
                              right
                              locale="en-US"
                              :min="min"
                              :date-disabled-fn="dateDisabled"
                              :start-weekday="fetchStartWeekday"
                            ></b-form-datepicker>
                          </b-input-group-append>
                          <b-form-invalid-feedback id="day_two_text-feedback">{{ veeErrors.first('day_two_text') }}</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </div>
                  </div>

                  <!-- Shift selection, attachment, comment, action buttons -->
                  <div class="my-2" v-if="this.fdata.leave_type_id != null">
                    <div class="row">

                      <div class="col-sm-12">
                        <template v-if="is_roster && this.day_one">
                          <p>Select Assigned Shift</p>

                          <div
                            v-if="this.assignments.length > 0"
                            class="position-relative mb-3"
                            ref="assignment_dropdown"
                          >
                            <button
                              type="button"
                              class="form-control d-flex justify-content-between align-items-center text-left overflow-hidden bg-white cursor-pointer assignment-toggle"
                              @click.prevent="toggleAssignmentDropdown"
                            >
                              <span
                                class="assignment-toggle-label d-block overflow-hidden"
                                :class="selectedAssignments.length ? 'has-selection' : 'is-placeholder'"
                              >
                                {{ selectedAssignments.length ? getSelectedAssignmentNames() : 'Select Assignments' }}
                              </span>
                              <b-icon class="ml-3 assignment-toggle-caret" icon="caret-down-fill"></b-icon>
                            </button>

                            <div v-if="openAssignmentDropdown" class="assignment-menu position-absolute rounded p-2 bg-white border">
                              <label
                                v-for="s in assignments"
                                :key="s.id"
                                class="assignment-option d-flex align-items-center cursor-pointer p-1 m-0 font-weight-normal rounded"
                              >
                                <input
                                  class="assignment-checkbox"
                                  type="checkbox"
                                  :value="s.id"
                                  v-model="selectedAssignments"
                                />
                                <span class="ml-2">
                                  {{ moment(s.period_date).format('YYYY-MM-DD') }} |
                                  {{ s.shift ? s.shift.code : '' }} |
                                  {{ s.shift ? s.shift.start_time : '' }} →
                                  {{ s.shift ? s.shift.end_time : '' }}
                                  <template v-if="s.shift">({{ s.shift.name }})</template>
                                </span>
                              </label>
                            </div>
                          </div>

                          <div v-else>
                            <p class="text-danger text-center">{{ no_shift_text }}</p>
                          </div>
                        </template>
                      </div>

                      <div class="col-sm-6">
                        <!--
                        <template>
                          <b-form-group id="flg_status-group" label="Leave Status" class="required-field" label-for="flg_status">
                            <b-form-select id="flg_status" name="flg_status" v-model="fdata.flg_status">
                              <b-form-select-option v-for="leavetatus in leavestatus" :key="leavetatus.value" :value="leavetatus.value">{{ leavetatus.text }}</b-form-select-option>
                            </b-form-select>
                          </b-form-group>
                        </template>
                        -->

                        <b-form-group id="attachment-group" label="Attachment" label-for="attachment">
                          <b-form-file
                            id="attachment"
                            v-model="attachment"
                            @change="checkFileType($event , 'attachment', ['.jpg', '.png', '.gif', '.pdf'])"
                            accept=".jpg, .png, .gif, .pdf"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            aria-describedby="form_etin_scan-feedback"
                            data-vv-as="Attachment"
                          ></b-form-file>
                        </b-form-group>
                      </div>

                      <div class="col-sm-6">
                        <b-form-group id="comment-group" class="required-field" label="Reason/Comment" label-for="comment">
                          <b-form-textarea
                            id="comment"
                            name="comment"
                            rows="5"
                            max-rows="6"
                            no-resize
                            v-model="fdata.comment"
                            v-validate="{ required: true, min: 3 }"
                            :state="validateState('comment')"
                            aria-describedby="comment-feedback"
                            data-vv-as="Reason/Comment"
                          ></b-form-textarea>
                          <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                        </b-form-group>
                      </div>

                    </div>

                    <div class="clearfix">
                      <template v-if="show_reset == 1">
                        <div class="float-left mr-2">
                          <b-button v-if="toggle_reset" @click="changeDate" type="button">Change Date / Type</b-button>
                          <b-button v-else @click="resetChangeDate" type="button">Reset</b-button>
                        </div>

                        <b-button @click="deleteLeave" type="button" class="mx-2">Delete</b-button>
                      </template>

                      <div class="float-left">
                        <b-button @click="showReplacementModal" :disabled="disable_flg">Save</b-button>
                      </div>

                      <div v-if="(dateDiff || days) && day_one" class="float-right font-italic" :class="my_class">
                        <span v-if="!is_roster">Affected Day(s) :</span>
                        <span v-else>Affected Shift(s) :</span>
                        <span v-if="toggle_reset">{{ days }}</span>
                        <span v-else>{{ dateDiff }}</span>
                      </div>
                      <div v-if="excess" class="float-right font-italic mx-2" :class="my_class">Exceeded Leave!</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Application list -->
            <div class="col-sm-4">
              <div class="card">
                <table class="w-100">
                  <tr class="table-head w-100">
                    <td class="w-100">List of Leave Applications</td>
                  </tr>
                </table>
                <div class="card-body leave-list-body">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item px-0" v-for="leave in leaves" :key="leave.leave_date">
                      <div
                        class="cursor-pointer"
                        :title="leave.leave_title + ' - ' + leave.comment"
                        v-b-tooltip
                        placement="right"
                        @click="updateLeave(leave.id)"
                      >
                        <a class="edit-icon mr-2 float-none d-inline-block" href="#" @click="updateLeave(leave.id)">
                          <b-icon icon="pencil"></b-icon>
                        </a>
                        {{ formatdate(leave.leave_date) }} - {{ leave.status }}
                      </div>
                    </li>
                  </ul>
                  <div v-if="leaves.length == 0">
                    {{ blankmsg }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Single-leave status modal -->
            <b-modal id="bv-modal-leave" hide-footer v-bind:title="leave_details.leave_date" v-if="ce">
              <b-form @submit.stop.prevent="onSubmitLeaveUpdate">
                <input type="hidden" v-model="leave_details.id" name="id">

                <b-form-group id="status-group" label="Status" label-for="status">
                  <b-form-select
                    id="status"
                    name="status"
                    v-model="leave_details.flg_status"
                    v-validate="{ required: true }"
                    :options="leavestatus"
                  ></b-form-select>
                </b-form-group>

                <div class="d-flex justify-content-center align-items-center">
                  <b-button type="submit" variant="primary">Submit</b-button>
                </div>
              </b-form>
            </b-modal>
          </div>

          <!-- ============================================================ -->
          <!-- Allowed leaves summary table                                  -->
          <!-- ============================================================ -->
          <div class="row mt-4">
            <div class="col-sm-12">
              <h5 class="mb-3 pb-3">Allowed Leaves</h5>
              <table class="table">
                <thead>
                  <tr class="table-head">
                    <th>Type</th>
                    <th>Leaves Allowed</th>
                    <th v-if="carry == 1">Carried</th>
                    <th>Applied</th>
                    <th>Enjoyed</th>
                    <th v-if="encash == 1">Encashed</th>
                    <th>Deducted</th>
                    <th>Remaining</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row hover-bg" v-for="leave_type in leave_available" :key="leave_type.id">
                    <td>{{ leave_type.leave_title }}</td>
                    <td>
                      {{ leave_type.allowed }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                    <td v-if="carry == 1">
                      {{ leave_type.carried }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                    <td>
                      {{ leave_type.applied }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                    <td>
                      {{ leave_type.enjoyed }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                    <td v-if="encash == 1">
                      {{ leave_type.encashed }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                    <td>
                      {{ leave_type.deducted }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                    <td>
                      {{ leave_type.remaining }}
                      <span v-if="is_roster">Shifts</span>
                      <span v-else>Days</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </template>

        <template v-else>
          <div class="vertical-center">
            <div class="container font-weight-bold text-danger">
              No active contract found.
            </div>
          </div>
        </template>
      </template>

      <template v-else-if="has_contract == false">
        <div class="vertical-center">
          <div class="container font-weight-bold text-danger">
            No active contract found.
          </div>
        </div>
      </template>

      <template v-else>
        <div class="vertical-center" v-if="show_warning">
          <div class="container font-weight-bold text-danger">
            No leave policy defined or assigned leave policy doesn't have any day amount defined or leave year not unlocked!
          </div>
        </div>
      </template>

      <!-- ============================================================ -->
      <!-- Replacement assignment modal                                  -->
      <!-- ============================================================ -->
      <b-modal id="reassign-leave-modal" size="lg" centered hide-footer title="Leave Request" modal-class="alm-modal">
        <b-overlay :show="showoverlay">

          <b-card class="alm-section mb-3 p-0">
            <div class="alm-section-title px-3 pt-3 pb-2">
              <b-icon icon="person-lines-fill" class="mr-2"></b-icon>
              Leave Request Details
            </div>
            <div class="px-3 pb-3">
              <b-card no-body class="alm-details">
                <div class="row no-gutters">
                  <div class="col-md-6 py-2 px-3">
                    <div class="alm-kv">
                      <div class="alm-k">Employee</div>
                      <div class="alm-v">{{ employeeLeaveDetails.employee }}</div>
                    </div>
                    <div class="alm-kv">
                      <div class="alm-k">Leave Category</div>
                      <div class="alm-v">{{ employeeLeaveDetails.leaveType }}</div>
                    </div>
                    <div class="alm-kv">
                      <div class="alm-k">Period</div>
                      <div class="alm-v">{{ employeeLeaveDetails.period }}</div>
                    </div>
                  </div>
                  <div class="col-md-6 py-2 px-3">
                    <div class="alm-kv">
                      <div class="alm-k">Department</div>
                      <div class="alm-v">{{ employeeLeaveDetails.department }}</div>
                    </div>
                    <div class="alm-kv">
                      <div class="alm-k">Duration</div>
                      <div class="alm-v">{{ employeeLeaveDetails.duration }}</div>
                    </div>
                    <div class="alm-kv">
                      <div class="alm-k">Reason</div>
                      <div class="alm-v text-muted">{{ employeeLeaveDetails.reason }}</div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </b-card>

          <b-card class="alm-section p-0">
            <div class="alm-section-title px-3 pt-3 pb-2">
              <b-icon icon="people" class="mr-2"></b-icon>Replacement Assignment
            </div>

            <div class="px-3 pb-3">
              <div class="mb-2 font-weight-500">Replacement Assignment Mode</div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <div class="alm-mode-card" :class="{ active: mode == 0 }" role="button" @click="mode = 0">
                    <div class="d-flex align-items-start">
                      <div class="alm-dot mr-2" :class="{ on: mode == 0 }"></div>
                      <div>
                        <div class="font-weight-600 mb-1">Keep empty</div>
                        <div class="text-muted small">
                          No replacement employees for each date
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="alm-mode-card" :class="{ active: mode == 1 }" role="button" @click="mode = 1;">
                    <div class="d-flex align-items-start">
                      <div class="alm-dot mr-2" :class="{ on: mode == 1 }"></div>
                      <div>
                        <div class="font-weight-600 mb-1">Manual Assignment</div>
                        <div class="text-muted small">
                          Manually select replacement employees from available staff for each shift
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for="(shifts_arr, date) in employeeLeaveDetails.shifts" :key="date" class="w-100">
                <b-list-group-item
                  v-for="shift in shifts_arr"
                  :key="`${date}-${shift.id}`"
                  class="d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="rounded-circle mr-3 shift-color-dot"
                      :style="{ backgroundColor: shift.color }"
                    ></div>

                    <div>
                      <div class="font-weight-bold">
                        {{ shift.name }} ({{ shift.code }}) → Period Date:<span class="font-weight-normal">{{ date }}</span>
                      </div>
                      <small class="text-muted">
                        {{ moment(shift.start_time, 'hh:mm A').format('hh:mm A') }} → {{ moment(shift.end_time, 'hh:mm A').format('hh:mm A') }}
                      </small>
                    </div>
                  </div>

                  <div class="replacement-select-wrap">
                    <div
                      v-if="unassigned_employees[date][String(shift.id)]"
                      class="d-flex flex-row justify-content-end align-items-center"
                    >
                      <b-form-select
                        :disabled="isPastDate(date)"
                        :value="selected_unassigned_employees[date][String(shift.id)]"
                        @input="val => setSelected(date, shift.id, val)"
                        :options="unassigned_employees[date][String(shift.id)]"
                        size="sm"
                        class="w-100"
                      ></b-form-select>

                      <b-button class="px-1 py-0 ml-1" variant="danger" @click="setSelected(date, shift.id, null)">
                        <b-icon icon="x-circle"></b-icon>
                      </b-button>
                    </div>

                    <b-form-select v-else disabled size="sm" class="w-100" placeholder="No unassigned employees"></b-form-select>
                  </div>
                </b-list-group-item>
              </div>

            </div>
          </b-card>

          <div class="d-flex justify-content-between align-items-center mt-3">
            <b-button variant="outline-secondary" @click="$bvModal.hide('reassign-leave-modal')">Cancel</b-button>
            <b-button v-if="mode == 0" variant="success" class="px-4" @click="saveLeave">
              <b-icon icon="check2-circle" class="mr-1"></b-icon>Submit
            </b-button>
            <b-button v-else variant="success" class="px-4" @click="replaceShifts">
              <b-icon icon="check2-circle" class="mr-1"></b-icon>Submit with Replacements
            </b-button>
          </div>

        </b-overlay>
      </b-modal>

    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment'

export default {

  props: [
    'editflg',
    'leave_type_id',
    'flg_status',
    'from',
    'to',
    'attendances_date',
    'leave_day',
    'period_date',
  ],

  components: {},

  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDateStr = new Date(today.getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10)

    return {
      carry: 0,
      encash: 0,
      showoverlay: false,
      loading: false,
      disable_flg: false,
      openAssignmentDropdown: false,
      no_shift_text: 'Loading...',
      blankmsg: 'Fetching data..',
      my_class: '',
      editable: '',
      ce: true,
      show_reset: 0,
      toggle_reset: false,
      show_warning: false,
      show_form: false,

      startDate: '',
      endDate: '',
      min: minDateStr,
      day_one: '',
      day_two: '',
      days: 0,
      is_holiday: false,
      all_week_holidays: [],
      holidays_date_arr: [],
      skip_days: [],
      off_day_on_leave: 0,

      fdata: {
        day_one: this.day_one,
        day_two: this.day_two,
        days: null,
        leave_type_id: null,
        flg_status: 0,
        comment: null,
        is_roster: 1,
        leave_day: 0,
      },
      attachment: null,
      ids: 0,

      // ---- Leave data ----
      leaves: [],
      leave_limit: [],
      leave_available: [],
      excess_leaves: [],
      excess: false,
      leave_events: [],
      leave_details: {},
      leavetypes: [],
      has_contract: true,
      company_id: 0,
      errors: [],

      assignments: [],
      selectedAssignments: [],
      mode: 0,
      unassigned_employees: [],
      selected_unassigned_employees: {},
      employeeLeaveDetails: {
        leave: null,
        employee: '',
        department: '',
        jobposition: '',
        leaveType: '',
        duration: '',
        period: '',
        reason: '',
        shifts: [],
      },

      // ---- Static option lists ----
      count_options: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
      ],
      options: [
        { text: 'Friday', value: '5' },
        { text: 'Saturday', value: '6' },
        { text: 'Sunday', value: '0' },
        { text: 'Monday', value: '1' },
        { text: 'Tuesday', value: '2' },
        { text: 'Wednesday', value: '3' },
        { text: 'Thursday', value: '4' },
      ],
      leavestatus: [
        { text: 'Applied', value: '0' },
        { text: 'Approved', value: '1' },
        { text: 'Declined', value: '2' },
      ],
      leaveDay: [
        { text: 'Full Day', value: '0' },
        { text: 'First Half', value: '1' },
        { text: 'Second Half', value: '2' },
      ],
    }
  },

  computed: {
    leaveType() {
      let type = this.leavetypes.find(({ leave_type_id }) => leave_type_id == this.fdata.leave_type_id);
      return type || null;
    },

    is_roster() {
      let type = this.leaveType;
      if (type) {
        return type.leave_basis;
      }
      return 0;
    },

    dateDiff() {
      this.disable_flg = false;
      this.my_class = '';
      this.excess = false;

      if (this.fdata.leave_type_id == null) {
        return '';
      }

      let days = 0;

      if (this.is_roster) {
        if (this.selectedAssignments.length <= 0) {
          return;
        }

        days = this.selectedAssignments.length;
        this.fdata.days = days;
      } else {
        let day_one = moment(this.day_one);
        let day_two = moment(this.day_two);

        this.fdata.day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
        this.fdata.day_two = moment(String(this.day_two)).format('YYYY-MM-DD');

        if (this.leaveType != null && this.leaveType.event == 0) {
          if (!this.checkValidDate(this.fdata.day_one) || !this.checkValidDate(this.fdata.day_two)) {
            this.fdata.days = 0;
            this.disable_flg = true;
            this.my_class = 'danger';
            return 'Wrong Leave Year!';
          }
        }

        if (day_two.isBefore(day_one, 'day')) {
          this.fdata.days = 0;
          this.disable_flg = true;
          this.my_class = 'danger';
          return 'Invalid Date Range';
        }

        if (this.leaveType.off_day_on_leave == 1) {
          days = 0;
          for (let m = moment(this.day_one); m.isSameOrBefore(this.day_two, 'day'); m.add(1, 'days')) {
            if (this.skip_days.includes(m.format('YYYY-MM-DD'))) {
              continue;
            }
            days++;
          }
        } else {
          days = day_two.diff(day_one, 'days') + 1;
        }

        this.fdata.days = days;

        if (this.leave_events[this.fdata.leave_type_id] != undefined) {
          if (this.leave_events[this.fdata.leave_type_id] === true) {
            return days;
          }
        }
      }

      if (days <= 0) {
        this.fdata.days = 0;
        this.disable_flg = true;
        this.my_class = 'danger';
        return 'Invalid Date Range';
      }

      let limit = this.leave_limit[this.fdata.leave_type_id] || 0;

      if (days <= limit) {
        this.disable_flg = false;
        this.my_class = '';
        this.excess = false;
        return days;
      }

      if (this.excess_leaves && this.excess_leaves[this.fdata.leave_type_id] === true) {
        this.disable_flg = false;
        this.my_class = 'danger';
        this.excess = true;
        return days;
      }

      this.disable_flg = true;
      this.my_class = 'danger';
      this.excess = false;
      return 'Limit Exceed!';
    },

    fetchStartWeekday() {
      return this.week_start_day;
    },
  },

  created: function () {
    this.getCompanyLeaveSettings();
    this.getEmployeeLeaveSettings();
    this.getDisabledDates();
    this.getEmployeeDetails();

    if (this.period_date) {
      this.day_one = this.period_date;
      this.fdata.day_one = this.period_date;
      this.fdata.day_two = this.period_date;
    }

    if (this.editflg == 1) {
      this.fetchLeavesByRangeTypeStatus();
      this.toggle_reset = true;
    } else if (this.attendances_date != null) {
      this.fdata.day_one = this.attendances_date;
      this.day_one = this.attendances_date;
    }
  },

  mounted() {
    document.addEventListener('click', this.closeAssignmentDropdown);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeAssignmentDropdown);
  },

  methods: {
    moment,

    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.carry = response.data.carry;
          this.encash = response.data.encash;
        }
      }.bind(this));
    },
    reloadType: function () {
      var x = this.fdata.leave_day;
      if (x > 0) {
        this.fdata = { leave_day: x, day_one: this.day_one, day_two: this.day_one, days: null, leave_type_id: null, flg_status: 0, comment: null };
        this.day_two = this.day_one;
      }
      this.getLeaveTypeByLeavePolicy(x);
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    checkFileType(e) {
      const f = e && e.target && e.target.files && e.target.files[0] ? e.target.files[0] : null;
      if (!f) return;
      const ok = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
      if (!ok.includes(f.type)) {
        this.$bvToast.toast('Unsupported file type.', { variant: 'danger', solid: true });
        this.attachment = null;
      }
    },

    closeAssignmentDropdown(event) {
      if (
        this.$refs.assignment_dropdown &&
        !this.$refs.assignment_dropdown.contains(event.target)
      ) {
        this.openAssignmentDropdown = false;
      }
    },

    toggleAssignmentDropdown() {
      this.openAssignmentDropdown = !this.openAssignmentDropdown;
    },

    getSelectedAssignmentNames() {
      return this.assignments
        .filter(s => this.selectedAssignments.includes(s.id))
        .map(s => {
          let shift = s.shift || {};
          return `${moment(s.period_date).format('YYYY-MM-DD')} | ${shift.code || ''}`;
        })
        .join(', ');
    },

    getShiftsDateRange() {
      const start = this.day_one;
      const end = this.day_two;

      if (!start || !end || isNaN(Date.parse(start)) || isNaN(Date.parse(end))) {
        this.assignments = [];
        this.selectedAssignments = [];
        return;
      }

      this.loading = true;

      axios.get(this.$api_url + '/leave-attendance/shift-by-date-range', {
        params: { start, end, day: this.fdata.leave_day }
      }).then(res => {
        this.assignments = res.data;
        if (this.assignments.length == 0) {
          this.no_shift_text = 'This date is not available for leave application.';
        }
        this.selectedAssignments = [];
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.serverError(err);
      });
    },

    formatdate: function (x) {
      return moment(x).format('YYYY-MM-DD');
    },

    checkGaterDate(x) {
      return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
    },

    isPastDate(date) {
      if (!date) return false;
      return moment(date, 'YYYY-MM-DD').isBefore(moment(), 'day');
    },

    checkValidDate(date) {
      if (!this.startDate || !this.endDate) return true;
      return this.startDate <= date && date <= this.endDate;
    },

    dateDisabled(ymd, date) {
      const x = moment(String(date)).format('YYYY-MM-DD');
      if (this.leaveType != null && this.leaveType.event == 0) {
        if (this.startDate && this.endDate) {
          if (x < this.startDate || x > this.endDate) {
            return true;
          }
        }
      }
      if (this.is_holiday) {
        return this.all_week_holidays.includes(x) || this.holidays_date_arr.includes(x) || this.skip_days.includes(x);
      } else {
        return false;
      }
    },

    updateToDate: function () {
      if(!this.day_one) return;
      if (this.leaveType != null) {
        const isEvent = this.leaveType.event;

        if (isEvent > 0) {
          this.min = this.day_one;

          if (this.day_one) {
            this.day_two = moment(this.day_one, 'YYYY-MM-DD').add(Number(this.leaveType.leave_days) - 1, 'days').format('YYYY-MM-DD');
          }

          this.fdata.day_one = this.day_one;
          this.fdata.day_two = this.day_two;

          if (this.is_roster) {
            this.getShiftsDateRange();
          }
        } else {
          this.min = this.day_one;

          if (this.leaveType && this.leaveType.off_day_on_leave == 2) {
            this.pushBackStartDate(this.day_one);
          } else {
            this.day_two = this.day_one;
          }

          this.fdata.day_one = this.day_one;
          this.fdata.day_two = this.day_two;
        }
      }
    },

    pushBackStartDate: function (x) {
      let m = moment(x);
      m.add(-1, 'days');
      if (this.skip_days.includes(m.format('YYYY-MM-DD'))) {
        this.day_two = '';
        this.day_one = m.format('YYYY-MM-DD');
        this.pushBackStartDate(this.day_one);
      }
    },

    adjustValidDate: function () {
      if (moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD'))) {
        this.day_two = this.day_one;
      }
      else if (
        !this.leaveType?.event &&
        moment(this.day_two).isAfter(moment(this.endDate).format('YYYY-MM-DD'))
      ) {
        this.day_two = this.day_one;
      }
      else {
        if (this.leaveType && this.leaveType.off_day_on_leave == 2) {
          let n = moment(this.day_two);
          n.add(1, 'days');
          if (this.skip_days.includes(n.format('YYYY-MM-DD'))) {
            this.day_two = n.format('YYYY-MM-DD');
            this.adjustValidDate();
          }
        }
      }

      if (this.is_roster) this.getShiftsDateRange();
    },

    getEmployeeLeaveSettings: function () {
      axios.get(this.$api_url + '/leave-attendance/employee/leave/settings').then((response) => {
        if (response.data.length != 0) {
          this.company_id = response.data.company_id;
          this.week_start_day = response.data.week_start_day;
          this.off_day_on_leave = response.data.off_day_on_leave;
          this.is_holiday = response.data.is_holiday;
          this.getLeaves();
          
        }
      });
    },

    getDisabledDates: function () {
      axios.get(this.$api_url + '/leave-attendance/holidays/details').then(function (response) {
        if (response.data.length != 0) {
          this.all_week_holidays = response.data.report.week_holidays;
          this.week_start_day = response.data.report.week_start_day;
          this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function (item) { return item; });
        }
      }.bind(this));
    },

    getLeaveTypeByLeavePolicy: function (f = 0) {
      if (!this.checkNet()) return false;

      axios.get(this.$api_url + '/leave-attendance/leave/type/policy?f=' + f).then((response) => {
        this.leavetypes = response.data;

        if (this.leavetypes.length > 0)
          this.show_warning = false;
        else
          this.show_warning = true;
      });
    },

    getLeaves: function () {
      this.showoverlay = true;
      axios.get(this.$api_url + '/leave-attendance/employee/leaves').then((response) => {
        if (response.data.length != 0) {
          this.leaves = response.data.leave_data || [];
          this.leave_limit = response.data.limit || [];
          this.leave_available = response.data.available || [];
          this.excess_leaves = response.data.excess_leaves || {};
          this.leave_events = response.data.leave_events;
          this.skip_days = response.data.skip_days;

          this.startDate = response.data.range.leave_limit_start_date;
          this.endDate = response.data.range.leave_limit_end_date;

          if (this.leaves.length == 0) {
            this.blankmsg = 'Looks like no leave applied for the employee yet.';
          }

          this.show_warning = this.leave_limit.length == 0;
          this.has_contract = true;

          this.getLeaveTypeByLeavePolicy();
        }
        else {
          this.has_contract = false;
        }

        this.showoverlay = false;
      }).catch((error) => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    getEmployeeDetails() {
      axios.get(this.$api_url + '/employee/publicinfo').then(response => {
        this.employeeLeaveDetails.employee = response.data.name;
        this.employeeLeaveDetails.department = response.data.department;
        this.employeeLeaveDetails.jobposition = response.data.jobposition;
      });
    },

    fetchLeavesByRangeTypeStatus: function () {
      this.day_one = this.from;
      this.day_two = this.to;
      this.fdata.leave_type_id = this.leave_type_id;

      let formData = new FormData();
      formData.append('leave_type_id', this.leave_type_id);
      formData.append('flg_status', this.flg_status);
      formData.append('from', this.from);
      formData.append('to', this.to);

      axios.post(this.$api_url + '/leave-attendance/employee/leaves/range', formData).then((response) => {
        this.fdata.comment = response.data.comment;
        this.fdata.flg_status = response.data.flg_status;
        this.days = response.data.days;
        this.ids = response.data.ids;
        this.show_reset = 1;
      }).catch((error) => {
        this.serverError(error);
      });
    },

    // ---------------------------------------------------------------
    // Edit mode (change date / reset)
    // ---------------------------------------------------------------
    resetChangeDate: function () {
      this.showoverlay = true;
      this.toggle_reset = !this.toggle_reset;

      this.getEmployeeLeaveSettings();
      this.getLeaveTypeByLeavePolicy();
      this.getLeaves();

      if (this.editflg == 1) {
        this.fetchLeavesByRangeTypeStatus();
      }

      setTimeout(() => { this.showoverlay = false; }, 1000);
    },

    changeDate: function () {
      this.showoverlay = true;
      this.editable = '';

      this.toggle_reset = !this.toggle_reset;
      this.fdata.flg_status = 0;

      this.leave_available.forEach((element, index) => {
        if (element.leave_type_id == this.leave_type_id) {
          this.leave_available[index].remaining_days = this.leave_available[index].remaining_days + this.days;
          this.leave_limit[this.leave_type_id] = (this.leave_limit[this.leave_type_id]) + this.days;
        }

        this.day_one = this.from;
        this.fdata.leave_type_id = this.leave_type_id;
        setTimeout(() => { this.showoverlay = false; }, 1000);
        this.day_two = this.to;
      });

      this.showoverlay = false;
    },

    // ---------------------------------------------------------------
    // Leave CRUD
    // ---------------------------------------------------------------
    updateLeave: function (x) {
      axios.get(this.$api_url + '/leave-attendance/employee/leave/details?id=' + x).then((response) => {
        this.leave_details = response.data;
      });
      this.$bvModal.show('bv-modal-leave');
    },

    deleteLeave: function () {
      this.showoverlay = true;
      let formData = new FormData();
      formData.append('leave_type_id', this.leave_type_id);
      formData.append('flg_status', this.flg_status);
      formData.append('from', this.from);
      formData.append('to', this.to);

      axios.post(this.$api_url + '/leave-attendance/leave/delete/range', formData).then((response) => {
        this.$bvToast.toast('Deleted!', {
          title: `Success`,
          variant: 'success',
          solid: true
        });

        setTimeout(() => {
          this.$emit('childToParent');
          this.showoverlay = false;
        }, 1000);
      }).catch((error) => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    onSubmitLeaveUpdate: function () {
      this.showoverlay = true;
      let formData = new FormData();
      for (let [key, value] of Object.entries(this.leave_details)) {
        var nm = `${key}`;
        var fval = `${value}`;
        formData.append(nm, fval);
      }
      axios.post(this.$api_url + '/leave-attendance/employee/leave/details', formData,).then((response) => {
        this.$bvToast.toast('Saved!', {
          title: `Success`,
          variant: 'success',
          solid: true
        });

        this.getLeaves();
        this.$bvModal.hide('bv-modal-leave');
        this.$emit('childToParent');
        this.showoverlay = false;
      }).catch((error) => {
        this.showoverlay = false;
        this.serverError(error);
      });
    },

    saveLeave: function () {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        if (this.is_roster) {
          if (this.selectedAssignments.length == 0) {
            this.disable_flg = true;
            this.$bvToast.toast('No shifts selected', {
              solid: true,
              title: 'Failed',
              variant: 'danger'
            });
            this.disable_flg = false;
            return;
          }

          if (this.selectedAssignments.length > 1 && this.fdata.leave_day > 0) {
            this.disable_flg = true;
            this.$bvToast.toast('Half day leave cannot be applied on more than one shift.', {
              solid: true,
              title: 'Failed',
              variant: 'danger'
            });
            this.disable_flg = false;
            return;
          }

          let selected = this.assignments.filter(({ id }) => this.selectedAssignments.includes(id));
          if (selected.length) {
            let dates = selected.map(s => new Date(s.period_date).getTime());
            let day_one = new Date(Math.min(...dates));
            let day_two = new Date(Math.max(...dates));

            // keep both fdata and local inputs in sync
            this.fdata.day_one = day_one.toISOString().split('T')[0];
            this.fdata.day_two = day_two.toISOString().split('T')[0];
            this.day_one = this.fdata.day_one;
            this.day_two = this.fdata.day_two;
          }
        }

        let formData = new FormData();

        if (this.editflg == 1) {
          formData.append('ids', this.ids);
        }

        if (!this.toggle_reset) {
          formData.append('removeids', this.ids);
        }

        for (let [key, value] of Object.entries(this.fdata)) {
          var nm = `${key}`;
          var fval = `${value}`;
          formData.append(nm, fval);
        }

        if (this.attachment) {
          formData.append('attachment', this.attachment);
        }
        formData.append('assignment_ids', JSON.stringify(this.selectedAssignments));

        this.showoverlay = true;

        formData.append('is_roster', this.is_roster ? 1 : 0);
        axios.post(this.$api_url + '/leave-attendance/employee/leaves/save', formData).then((response) => {
          if (response.data.status) {
            this.$bvToast.toast('Saved!', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            setTimeout(() => {
              this.$emit('childToParent');
              this.$emit('hideModal');
              this.$bvModal.hide('bv-modal-add-leave');
              this.showoverlay = false;
            }, 1000);
          }
          else {
            this.showoverlay = false;
          }
          if(response.data.errors) {
            this.errors = response.data.errors;
          }
        }).catch((error) => {
          this.showoverlay = false;
          this.serverError(error);
        });
      });
    },

    // ---------------------------------------------------------------
    // Replacement assignment
    // ---------------------------------------------------------------
    setSelected(date, shiftId, val) {
      const sid = String(shiftId);
      if (!this.selected_unassigned_employees[date]) {
        this.$set(this.selected_unassigned_employees, date, {});
      }
      this.$set(this.selected_unassigned_employees[date], sid, val);
    },

    replaceShifts: function () {
      this.saveLeave();

      const payload = Object.entries(this.selected_unassigned_employees || {}).flatMap(([date, shiftsObj]) =>
        Object.entries(shiftsObj || {}).filter(([, employeeId]) => employeeId != null && employeeId !== '').map(([shiftId, employeeId]) => ({
          date, shift_id: Number(shiftId), employee_id: Number(employeeId),
        }))
      );
      const formData = new FormData();
      formData.append('payload', JSON.stringify(payload));
      axios.post(this.$api_url + '/leave-attendance/shift/reassign', formData).then(response => {
        this.$bvModal.hide('reassign-leave-modal');
        this.$bvToast.toast("Shifts Reassigned Successfully", {
          variant: 'success',
          title: 'Success',
          solid: true,
        });
        this.getLeavesNew();
      }).catch(e => {
        this.serverError(e);
      })
    },

    showReplacementModal() {
      if (this.fdata.flg_status != 1) {
        this.saveLeave();
        return;
      }

      if (!this.is_roster) {
        this.saveLeave();
        return;
      }

      if (this.selectedAssignments.length == 0) {
        this.$bvToast.toast('No shifts selected', {
          variant: 'danger',
          solid: true,
          title: 'Failed'
        });
        return;
      }

      let leave = {};
      leave.flg_status = this.fdata.flg_status;
      leave.from = this.fdata.day_one;
      leave.to = this.fdata.day_two;
      leave.days = this.dateDiff;
      leave.leave_type_id = this.fdata.leave_type_id;
      leave.leave_type = this.leavetypes.find(({ leave_type_id }) => this.fdata.leave_type_id == leave_type_id).leave_type_title;
      leave.is_roster = this.is_roster;
      let assignment_ids = Object.values(leave.shifts).flat().map(shift => shift.id);
      let assignment_map = Object.fromEntries(
        Object.entries(leave.shifts).map(([date, shifts]) => [
          date,
          shifts.map(shift => shift.id)
        ])
      );

      let formData = new FormData();
      formData.append('assignments', JSON.stringify(assignment_map));
      this.$bvModal.show('reassign-leave-modal')
      axios.post(this.$api_url + '/leave-attendance/employees/range/group', formData).then((res) => {
        if (res.data) {
          this.unassigned_employees = res.data;
          let day_type = 'shift';
          let days = assignment_ids.length;
          if (days > 1) day_type += 's';
          this.employeeLeaveDetails = {
            leave: leave,
            employee: this.employeeLeaveDetails.employee,
            department: this.employeeLeaveDetails.department,
            jobposition: this.employeeLeaveDetails.jobposition,
            leaveType: leave.leave_type,
            duration: this.dateDiff + ' ' + day_type,
            period: this.day_one + " to " + this.day_two,
            reason: this.fdata.comment,
            assignments: leave.assignments,
          };
          this.$bvModal.show('reassign-leave-modal')
        } else {
          this.unassigned_employees = {};
          this.saveLeave()
        }
      }).catch((err) => { this.serverError(err); }).finally(() => { this.showoverlay = false; });
    },
  },
}
</script>
